import { MessageType } from "./index";
import * as THREE from "three";

/* matUtils
 * Material関連のユーティリティクラス.
 */
export class matUtils {

    /* getColor
     * カラーを取得.
     */
    public static getColor(mat: THREE.Material): THREE.Color {
        // if (mat instanceof THREE.MeshBasicMaterial) {
        if (mat && mat.type == 'MeshBasicMaterial') {
            let basic = <THREE.MeshBasicMaterial>(mat);
            return basic.color;
        }
        // if (mat instanceof THREE.MeshLambertMaterial) {
        if (mat && mat.type == 'MeshLambertMaterial') {
            let lambert = <THREE.MeshLambertMaterial>(mat);
            return lambert.color;
        }
        // if (mat instanceof THREE.MeshPhongMaterial) {
        if (mat && mat.type == 'MeshPhongMaterial') {
            let phong = <THREE.MeshPhongMaterial>(mat);
            return phong.color;
        }
        if (mat && mat.type == 'MeshStandardMaterial') {
            let stand = <THREE.MeshStandardMaterial>(mat);
            return stand.color;
        }
        let color: THREE.Color = new THREE.Color;
        color.setRGB(0, 0, 0);
        return color;
    }

    // less risk of memory leaking..
    public static getColorString(mat: THREE.Material): string {
        // if (mat instanceof THREE.MeshBasicMaterial) {
        if (mat && mat.type == 'MeshBasicMaterial') {
            let basic = <THREE.MeshBasicMaterial>(mat);
            return basic.color.getHexString();
        }
        // if (mat instanceof THREE.MeshLambertMaterial) {
        if (mat && mat.type == 'MeshLambertMaterial') {
            let lambert = <THREE.MeshLambertMaterial>(mat);
            return lambert.color.getHexString();
        }
        // if (mat instanceof THREE.MeshPhongMaterial) {
        if (mat && mat.type == 'MeshPhongMaterial') {
            let phong = <THREE.MeshPhongMaterial>(mat);
            return phong.color.getHexString();
        }
        if (mat && mat.type == 'MeshStandardMaterial') {
            let phong = <THREE.MeshStandardMaterial>(mat);
            return phong.color.getHexString();
        }
        return "#000000";
    }

    /* setColor
     * カラーを設定.
     */
    public static setColor(mat: THREE.Material, color: THREE.Color): void {
        // if (mat instanceof THREE.MeshBasicMaterial) {
        if (mat && mat.type == 'MeshBasicMaterial') {
            let basic = <THREE.MeshBasicMaterial>(mat);
            basic.color = color;
        }
        // if (mat instanceof THREE.MeshLambertMaterial) {
        if (mat && mat.type == 'MeshLambertMaterial') {
            let lambert = <THREE.MeshLambertMaterial>(mat);
            lambert.color = color;
        }
        // if (mat instanceof THREE.MeshPhongMaterial) {
        if (mat && mat.type == 'MeshPhongMaterial') {
            let phong = <THREE.MeshPhongMaterial>(mat);
            phong.color = color;
        }
        if (mat && mat.type == 'MeshStandardMaterial') {
            let stand = <THREE.MeshStandardMaterial>(mat);
            stand.color = color;
        }
    }

    /* setObjectWireframe
     * ワイヤフレーム表示を設定.
     */
    public static setObjectWireframe(obj: THREE.Object3D, value: boolean): void {
        let mesh = <THREE.Mesh>(obj);
        if (mesh.isMesh) {
            matUtils.setWireframe(<any>mesh.material, value);
        }
        else if (obj.children != undefined) {
            for (let i = 0; i < obj.children.length; i++)
                this.setObjectWireframe(obj.children[i], value);
        }
    }

    /* setWireframe
     * ワイヤフレーム表示を設定.
     */
    public static setWireframe(mat: THREE.Material, value: boolean): void {
        // if (mat instanceof THREE.MeshBasicMaterial) {
        if (mat && mat.type == 'MeshBasicMaterial') {
            let basic = <THREE.MeshBasicMaterial>(mat);
            basic.wireframe = value;
        }
        else if (mat instanceof THREE.MeshLambertMaterial) {
            let lambert = <THREE.MeshLambertMaterial>(mat);
            lambert.wireframe = value;
        }
        else if (mat instanceof THREE.MeshPhongMaterial) {
            let phong = <THREE.MeshPhongMaterial>(mat);
            phong.wireframe = value;
        }
    }

    /* getImageMap
     * イメージマップを取得.
     */
    public static getImageMap(mat: THREE.Material): THREE.Texture {
        if (mat instanceof THREE.MeshBasicMaterial) {
            let basic = <THREE.MeshBasicMaterial>(mat);
            return basic.map;
        }
        else if (mat instanceof THREE.MeshLambertMaterial) {
            let lambert = <THREE.MeshLambertMaterial>(mat);
            return lambert.map;
        }
        else if (mat instanceof THREE.MeshPhongMaterial) {
            let phong = <THREE.MeshPhongMaterial>(mat);
            return phong.map;
        }
        return undefined;
    }

    /* setImageMap
     * イメージマップを適用.
     */
    public static setImageMap(mat: THREE.Material, tex: THREE.Texture): void {
        if (mat instanceof THREE.MeshBasicMaterial) {
            let basic = <THREE.MeshBasicMaterial>(mat);
            basic.map = tex;
        }
        else if (mat instanceof THREE.MeshLambertMaterial) {
            let lambert = <THREE.MeshLambertMaterial>(mat);
            lambert.map = tex;
        }
        else if (mat instanceof THREE.MeshPhongMaterial) {
            let phong = <THREE.MeshPhongMaterial>(mat);
            phong.map = tex;
        }
    }

    public static getMaterialFromName(materials: any, name: string): any {
        for (let i = 0; i < materials.length; i++) {
            if (materials[i].name == name)
                return materials[i];
        }
        return materials[0];
    }

    /* materialNames
     * マテリアル名を取得する.
     */
    public static materialNames(material: THREE.Material): string[] {
        if (material == undefined) return [];

        // マルチマテリアル判定 - マルチマテリアルでないなら配列化
        const materials = Array.isArray(material) ? material : [material];
        return materials.map((material) => material.name);      // マテリアル名称一覧
    }

    /* findMatFromName
     */
    public static findMatIndexFromName(material: THREE.Material, name: string): number {
        if (material == undefined) return undefined;

        const matchName = (material: THREE.Material, materialName: string) => (material.name != undefined) && material.name.match(materialName);

        if (Array.isArray(material)) {
            for (let i = 0; i < material.length; i++) {
                const result = matchName(material, name);
                if (result != undefined) return i;
            }
        } else {
            if (matchName(material, name)) return -1;
        }
        return undefined;
    }

    /* turnOffLights
     * 家具・備品の配置.
     */
    public static turnOffLights(obj: THREE.Object3D): void {
        obj.traverse((child) => {
            const light: THREE.Light = <THREE.Light>(child);
            if ((<THREE.Light>light).isLight) {
                light.intensity = 0.0;
            }
        });
    }

    /* setShineLevel
     */
    public static setShineLevel(obj: THREE.Object3D, value: number): void {
        obj.traverse(function (child) {
            if ((<THREE.Mesh>child).isMesh) {
                let mesh: THREE.Mesh = <THREE.Mesh>(child);
                matUtils.setShininess(<any>mesh.material, value);
            }
        });
    }

    /* setSpecularScale
     */
    public static setShininess(mat: THREE.Material, value: number): void {
        if (mat instanceof THREE.MeshPhongMaterial) {
            let phong = <THREE.MeshPhongMaterial>(mat);
            phong.shininess = phong.shininess * value;
        }
    }

    public static createMessageTexture(type: MessageType, messages: string[], subtexts: string[], completion: any, backImage?: string): void {
        if (typeof document != 'undefined') {
            let canvas: HTMLCanvasElement = document.createElement('canvas');
            canvas.width = 512; canvas.height = 256;
            let ctx = canvas.getContext('2d');
            ctx.font = "48px sans-serif";
            ctx.textAlign = 'center';

            ctx.fillStyle = 'rgb(84,66,48)';
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            let start: number = 60;
            ctx.fillStyle = '#ffff88';
            ctx.font = "48px sans-serif";
            for (let i = 0; i < messages.length; i++ , start += 50) {
                ctx.fillText(messages[i], 256, start);
            }

            start += 5;
            ctx.fillStyle = '#eeeeee';
            ctx.font = "24px sans-serif";
            ctx.textAlign = 'left';
            for (let i = 0; i < subtexts.length; i++ , start += 30) {
                ctx.fillText(subtexts[i], 30, start);
            }

            let texture = new THREE.Texture(canvas);
            texture.needsUpdate = true;
            completion(texture);

        }
        else {
            completion(undefined);
        }
    }

    public static createSizeTexture(size: string, color: string, completion: any, align?: string): void {
        if (typeof document != 'undefined') {
            if (align == undefined) align = 'center';
            let canvas = document.createElement('canvas');
            canvas.width = 256; canvas.height = 64;
            let ctx: any = canvas.getContext('2d');
            ctx.font = "64px sans-serif";
            ctx.textAlign = align;
            ctx.fillStyle = color;
            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = 0;
            ctx.shadowBlur = 8;
            ctx.shadowColor = 'rgba(0, 0, 0, 0.5)';
            ctx.fillText(size, 128, 60);

            // テクスチャを作成
            let texture = new THREE.Texture(canvas);
            texture.needsUpdate = true;
            completion(texture);
        }
        else {
            completion(undefined);
        }
    }

    public static setCastShadow(obj: THREE.Object3D, cast: boolean) {
        if (obj == undefined) return false;
        obj.castShadow = cast;
        if (cast) matUtils.setCastShadow(obj.parent, cast);
    }

    public static setRecvShadow(obj: THREE.Object3D, recv: boolean) {
        if (obj == undefined) return false;
        obj.receiveShadow = recv;
        if (recv) matUtils.setRecvShadow(obj.parent, recv);
    }
}
